import { SupplyKeyword } from '../../types/supply'
import { adminCollectionAccess } from '../constants'
import { SUPPLY_KEYWORDS } from '../names'
import { FirestoreCollection } from '../types'

// §6.7 CDI keyword library: authored only in the super-admin Charting Settings view and read
// server-side by the CDI scan (Admin SDK, bypasses rules). No practice/patient client access.
export const supplyKeywordsCollection: FirestoreCollection<SupplyKeyword> = {
  id: 'supplyKeywords',
  _type: 'firestoreCollection',
  name: 'Supply CDI Keywords',
  refPath: SUPPLY_KEYWORDS,
  access: adminCollectionAccess,
  defaultSort: 'supplyName',
}
